import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { 
  FileText, 
  Brain, 
  Search, 
  BarChart, 
  Database, 
  RefreshCw, 
  PenTool, 
  FileCheck 
} from 'lucide-react';

export const AlgorithmProcess = () => {
  const { t } = useTranslation();

  const steps = [
    { icon: FileText },
    { icon: Brain },
    { icon: Search },
    { icon: BarChart },
    { icon: Database },
    { icon: RefreshCw },
    { icon: PenTool },
    { icon: FileCheck }
  ];

  const algorithmSteps = t('algorithm.steps', { returnObjects: true });
  if (!Array.isArray(algorithmSteps)) return null;

  return (
    <section className="section py-24 overflow-hidden">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="text-center mb-16"
      >
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-6">
          {t('algorithm.title')}
        </h2>
        <p className="text-lg text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
          {t('algorithm.subtitle')}
        </p>
      </motion.div>

      <div className="max-w-5xl mx-auto">
        <div className="grid gap-8">
          {algorithmSteps.map((step, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: index % 2 === 0 ? -20 : 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="relative"
            >
              <div className="flex items-start gap-6 bg-white dark:bg-[#131314] p-6 rounded-2xl shadow-lg border border-gray-100 dark:border-gray-700/50">
                <div className="flex-shrink-0 w-12 h-12 rounded-xl bg-gray-100/40 dark:bg-black flex items-center justify-center">
                  {React.createElement(steps[index].icon, { 
                    size: 24,
                    className: "stroke-[var(--gradient-start)]"
                  })}
                </div>
                <div className="flex-grow">
                  <p className="text-lg text-gray-700 dark:text-gray-200">
                    {step}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};